/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Version/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'



/** @type {import('Simple/types.js').View} */
export default function Version({
  children,
  viewPath = "/App/Account/Content/Content/Home/Version"
  
}) {
let appVersionValueData = fromData.useDataValue({ viewPath,
context: 'app',
path: 'version',
})
let dtColorsNeutral600 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.600'
        })
  return (<React.Fragment
>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 fontSize={10}
 color={dtColorsNeutral600}
 data="app.version"
 text={appVersionValueData}
/>
{children}
</React.Fragment>)
}